import React from 'react'
import Projects from '../components/portfolio/Projects'
import FeaturedPosts from '../components/portfolio/FeaturedPosts'
import Layout from "../components/layout"
import SEO from "../components/SEO"

function portfolio() {
  return (
      <Layout>
		        <SEO title="Projects by Chintan Agrawal" description="Some fun projects that I have developed" />

           <main className="portfolio">
		   <Projects />
                <FeaturedPosts />
            </main>
      </Layout>
   
  )
}

export default portfolio
